function getSyncToastNotifications() {
  return JSON.parse(localStorage.getItem("toast_notifications")) || [];
}

function setSyncToastNotifications(notifications = []) {
  const existingNotifications = getSyncToastNotifications();

  const updatedErrors = [...existingNotifications, ...notifications];

  localStorage.setItem("toast_notifications", JSON.stringify(updatedErrors));
}

function clearSyncToastNotifications() {
  localStorage.removeItem("toast_notifications");
}

export {
  getSyncToastNotifications,
  setSyncToastNotifications,
  clearSyncToastNotifications,
};
